import { useGetHomeQuery } from "@/store/rest_api";
import { MembershipRole } from "@/enum/MembershipRole";
import { MembershipStatus } from "@/enum/MembershipStatus";

export function useCanExport() {
  const { data: user } = useGetHomeQuery();
  const membership = user?.activeMembership;
  const active = membership?.status === MembershipStatus.ACTIVE;
  const isOwner = active && membership?.role === MembershipRole.OWNER;
  const canExport = isOwner || (active && membership?.exportAccess === "ALLOWED");
  return { canExport, isOwner };
}
